// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.A4SWerMqPnBc3Yo91Cyf{width:127px}`, "",{"version":3,"sources":["webpack://./src/pages/keywords/pages/all/ui/EmptyStateKeywords/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA","sourcesContent":[".helpGuideButton {\n  width: 127px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpGuideButton": `A4SWerMqPnBc3Yo91Cyf`
};
export default ___CSS_LOADER_EXPORT___;
